"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gettext2 = require("./gettext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Textdomain = /*#__PURE__*/function (_Component) {
  _inherits(Textdomain, _Component);

  var _super = _createSuper(Textdomain);

  function Textdomain() {
    _classCallCheck(this, Textdomain);

    return _super.apply(this, arguments);
  }

  _createClass(Textdomain, [{
    key: "getChildContext",
    value: function getChildContext() {
      var self = this;
      return {
        gettext: self.gettext.bind(self),
        xgettext: self.xgettext.bind(self),
        ngettext: self.ngettext.bind(self),
        nxgettext: self.nxgettext.bind(self)
      };
    }
  }, {
    key: "gettext",
    value: function gettext(message) {
      var translations = this.props.translations;
      return (0, _gettext2.gettext)(translations, message);
    }
  }, {
    key: "ngettext",
    value: function ngettext(singular, plural, n) {
      var _this$props = this.props,
          translations = _this$props.translations,
          plurality = _this$props.plural;
      return (0, _gettext2.ngettext)(translations, plurality, singular, plural, n);
    }
  }, {
    key: "xgettext",
    value: function xgettext(message, context) {
      var translations = this.props.translations;
      return (0, _gettext2.xgettext)(translations, message, context);
    }
  }, {
    key: "nxgettext",
    value: function nxgettext(singular, plural, n, context) {
      var _this$props2 = this.props,
          translations = _this$props2.translations,
          plurality = _this$props2.plural;
      return (0, _gettext2.nxgettext)(translations, plurality, singular, plural, n, context);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children;
    }
  }]);

  return Textdomain;
}(_react.Component);

Textdomain.propTypes = {
  translations: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]))]),
  plural: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]),
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)])
};
Textdomain.defaultProps = {
  translations: {},
  plural: 'n != 1',
  children: []
};
Textdomain.childContextTypes = {
  gettext: _propTypes.default.func,
  ngettext: _propTypes.default.func,
  xgettext: _propTypes.default.func,
  nxgettext: _propTypes.default.func
};
var _default = Textdomain;
exports.default = _default;